import { render, staticRenderFns } from "./ObjectShuffle.vue?vue&type=template&id=3735fa61&scoped=true&"
import script from "./ObjectShuffle.vue?vue&type=script&lang=js&"
export * from "./ObjectShuffle.vue?vue&type=script&lang=js&"
import style0 from "./ObjectShuffle.vue?vue&type=style&index=0&id=3735fa61&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3735fa61",
  null
  
)

export default component.exports